import { render, staticRenderFns } from "./WeixinPay.vue?vue&type=template&id=4bcb1ca8&scoped=true&"
import script from "./WeixinPay.vue?vue&type=script&lang=js&"
export * from "./WeixinPay.vue?vue&type=script&lang=js&"
import style0 from "./WeixinPay.vue?vue&type=style&index=0&id=4bcb1ca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcb1ca8",
  null
  
)

export default component.exports